import TaskChit from '@/components/chit/TaskChit';
import { Tooltip, TooltipTypes } from '@/components/tooltip/Tooltip';
import { BASE_TOOLTIP_CLASSES } from '@/components/tooltip/tooltip.classes';
import { TaskType } from '@/services/tasks/task.types';
import { useActiveSkills } from '@/services/tasks/useSkills';
import { FunctionComponent } from 'react';

interface TeanMemberTaskChitProps {
  task: TaskType;
}

const TeanMemberTaskChit: FunctionComponent<TeanMemberTaskChitProps> = ({ task }) => {
  const skills = useActiveSkills();
  const requiredSkills = skills.filter(s => task.skills.includes(s.id));

  return (
    <TaskChit task={task}>
      <Tooltip type={TooltipTypes.info} className={BASE_TOOLTIP_CLASSES}>
        <div className="space-y-2">
          <p className="font-semibold text-md">Required Skills:</p>
          {requiredSkills.length === 0 ? (
            <p>None</p>
          ) : (
            requiredSkills.map(s => (
              <p key={s.id} className="text-sm">
                {s.displayName}
              </p>
            ))
          )}
        </div>
      </Tooltip>
    </TaskChit>
  );
};

export default TeanMemberTaskChit;
